import lodashGet from 'lodash/get';
import ImgPreview from '@web-common/components/UI/ImagePreview';
import { apiHolder, apis, emailPattern, emailNsPattern } from 'api';
import { randomName } from '@web-mail/components/ReadMail/util';
import toast from '@web-common/components/UI/Message/SiriusMessage';
import moment from 'moment';
import { ReactComponent as Statistics0 } from '@/images/icons/edm/statistics0.svg';
import { ReactComponent as Statistics1 } from '@/images/icons/edm/statistics1.svg';
import { ReactComponent as Statistics2 } from '@/images/icons/edm/statistics2.svg';
import { ReactComponent as Statistics3 } from '@/images/icons/edm/statistics3.svg';
import { ReactComponent as Statistics4 } from '@/images/icons/edm/statistics4.svg';
import { ReactComponent as Statistics5 } from '@/images/icons/edm/statistics5.svg';
import { ReactComponent as Statistics6 } from '@/images/icons/edm/statistics6.svg';
import { ReactComponent as Statistics7 } from '@/images/icons/edm/statistics7.svg';
import { ReactComponent as StatisticsNum } from '@/images/icons/edm/statistics-num.svg';
import { getIn18Text } from 'api';
export const EDMAPI = () => {
    const edmApi = apiHolder.api.requireLogicalApi(apis.edmSendBoxApiImpl);
    return edmApi;
};
export function exportExcel(listData, fieldLabels, fieldKeys, fileName) {
    let dataStr = '';
    fieldLabels.forEach((name, index) => {
        if (index === fieldLabels.length - 1) {
            dataStr += `"${name}"`;
        }
        else {
            dataStr += `"${name}",`;
        }
    });
    dataStr += '\r\n';
    listData.forEach(item => {
        fieldKeys.forEach((key, index) => {
            if (key.includes('+')) {
                let tempArr = new Array();
                key.split('+').forEach(subKey => {
                    const value = `${lodashGet(item, subKey, '')}`;
                    if (value.length > 0) {
                        tempArr.push(value);
                    }
                });
                dataStr += `"${tempArr.join('-')}",`;
            }
            else {
                dataStr += `"${lodashGet(item, key, '')}",`;
            }
        });
        dataStr += '\r\n';
    });
    const url = 'data:text/csv;charset=utf-8,\ufeff' + encodeURIComponent(dataStr);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${fileName}`;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
export function parseReceiverEntity(entity) {
    entity = entity.trim();
    if (entity.indexOf(',') > -1 || entity.indexOf('，') > -1) {
        const tmp = entity.split(/,|，/);
        return {
            contactName: tmp[0],
            contactEmail: tmp[1].trim(),
        };
    }
    if (entity.startsWith('"') && entity.endsWith('>')) {
        return {
            contactName: entity.substring(1, entity.lastIndexOf('"')),
            contactEmail: entity.substring(entity.indexOf('<') + 1, entity.lastIndexOf('>')),
        };
    }
    return {
        contactEmail: entity,
    };
}
let container = null;
export function getDataFromHtml(html) {
    if (!container)
        container = document.createElement('div');
    container.innerHTML = html;
    const table = container.getElementsByTagName('table')[0];
    if (!table) {
        return null;
    }
    const ret = [];
    for (let i = 0, rows = table.rows.length; i < rows; i++) {
        const row = table.rows[i];
        const rowData = [];
        for (let j = 0, cols = row.cells.length; j < cols; j++) {
            const cell = row.cells[j];
            rowData.push(cell.textContent || '');
        }
        ret.push(rowData);
    }
    return ret;
}
export function isValidEmailAddress(email) {
    return emailPattern.test(email);
}
export function isValidEmailAddressNs(email) {
    return emailNsPattern.test(email);
}
let guid = 0;
export function getNextId() {
    return guid++;
}
export function guardString(s) {
    return s && s.length > 0 ? true : false;
}
export function removeDeplicate(arr) {
    return Array.from(new Set(arr));
}
export const EdmStatColumns = [
    {
        title: getIn18Text('YINGXIAORENSHU'),
        dataIndex: 'contactsCount',
        position: 'list',
        Icon: StatisticsNum,
    },
    {
        title: getIn18Text('FAJIANZONGSHU'),
        dataIndex: 'sendCount',
        position: 'list',
        Icon: Statistics0,
    },
    {
        title: getIn18Text('FAJIANZONGSHU'),
        dataIndex: 'sendCount',
        hide: true,
        Icon: Statistics1,
    },
    {
        title: getIn18Text('SONGDAZONGSHU'),
        subtitle: getIn18Text('SONGDALV'),
        dataIndex: 'arriveCount',
        subIndex: 'arriveRatio',
        position: 'list',
        Icon: Statistics2,
        url: '/d/1640684506989031426.html',
    },
    [
        {
            title: getIn18Text('DAKAIRENSHU'),
            dataIndex: 'readCount',
            subtitle: getIn18Text('DAKAILV'),
            subIndex: 'readRatio',
            position: 'list',
            Icon: Statistics3,
            url: '/d/1674041360610545665.html',
        },
        {
            title: getIn18Text('DAKAICISHU'),
            dataIndex: 'readNum',
            Icon: Statistics3,
            url: '/d/1674041360610545665.html',
        },
    ],
    {
        title: getIn18Text('HUIFUZONGSHU'),
        dataIndex: 'replyCount',
        subtitle: getIn18Text('HUIFULV'),
        subIndex: 'replyRatio',
        position: 'list',
        Icon: Statistics4,
    },
    {
        title: getIn18Text('TUIDINGZONGSHU'),
        dataIndex: 'unsubscribeCount',
        Icon: Statistics5,
    },
    {
        title: getIn18Text('LIANJIEDIANJIRENSHU'),
        dataIndex: 'traceCount',
        Icon: Statistics6,
    },
    {
        title: getIn18Text('SHANGPINDIANJIRENSHU'),
        dataIndex: 'productClickNum',
        Icon: Statistics7,
    },
];
export const columnsFilter = (columns) => {
    return columns.filter(column => {
        if (Array.isArray(column)) {
            return true;
        }
        return column.position === 'list';
    });
};
export function toStatItem(info, maps = EdmStatColumns) {
    return maps.map(i => {
        if (Array.isArray(i)) {
            return i.map(item => mapItem(item, info));
        }
        return mapItem(i, info);
    });
}
const mapItem = (i, info) => {
    const obj = {
        title: i.title,
        num: info[i.dataIndex],
        hide: i.hide,
        Icon: i.Icon,
        url: i.url,
    };
    if (i.subtitle) {
        obj.subtitle = i.subtitle;
    }
    if (i.subIndex) {
        obj.subnum = info[i.subIndex];
    }
    return obj;
};
export const EmailStatusMap = {
    0: getIn18Text('DAIFASONG'),
    1: getIn18Text('FASONGZHONG'),
    2: getIn18Text('YIFASONG'),
    3: getIn18Text('FASONGSHIBAI'),
    4: getIn18Text('YICHEXIAO'),
    5: getIn18Text('LAJIYOUJIAN'),
    6: getIn18Text('YISHANCHU'),
};
export function transformStatus(emailStatus) {
    let statusKey = 'sended';
    if (emailStatus === 0)
        statusKey = '0';
    if (emailStatus === 1)
        statusKey = 'sending';
    if (emailStatus === 2)
        statusKey = '2';
    if (emailStatus === 5)
        statusKey = 'trash';
    if (emailStatus === 4)
        statusKey = 'canceled';
    if (emailStatus === 3)
        statusKey = 'error';
    return {
        statusKey,
        statusName: EmailStatusMap[emailStatus] || '',
    };
}
export const handlePreviewImage = (thumbnail, name) => {
    if (!thumbnail)
        return;
    const images = thumbnail.split(',');
    ImgPreview.preview({
        data: [
            {
                previewUrl: images[1] || images[0],
                downloadUrl: images[1] || images[0],
                name: name || randomName(),
            },
        ],
        startIndex: 0,
    });
};
export function onHttpError(e) {
    var _a, _b, _c, _d, _e, _f;
    if ((e === null || e === void 0 ? void 0 : e.status) >= 500 || (e === null || e === void 0 ? void 0 : e.code) === 40101)
        return;
    let msg = e;
    if (typeof e === 'string') {
        msg = '未知原因，请重试';
    }
    else if (e && e.message) {
        msg = e.message;
    }
    else if (e && ((_a = e.data) === null || _a === void 0 ? void 0 : _a.message)) {
        msg = (_b = e.data) === null || _b === void 0 ? void 0 : _b.message;
    }
    else if (e && ((_d = (_c = e.data) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.message)) {
        msg = (_f = (_e = e.data) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.message;
    }
    if (msg) {
        toast.error({ content: String(msg) });
    }
}
export function maskEmail(email) {
    const i = email.indexOf('@');
    return email.substring(0, 1) + '***' + email.substring(i);
}
export const filterTree = (menus, visibleKeys) => {
    const isSomeKeyVisible = Object.keys(visibleKeys).length !== 0;
    const ret = [];
    for (let i = 0, l = menus.length; i < l; i++) {
        const menu = Object.assign({}, menus[i]);
        const key = menu.label;
        if (!key || visibleKeys[key] || !isSomeKeyVisible) {
            if (menu.children !== undefined) {
                menu.children = filterTree(menu.children, visibleKeys);
            }
            if (!menu.children || menu.children.length > 0) {
                ret.push(menu);
            }
        }
    }
    return ret;
};
export function encodeHTML(str) {
    return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
export const getEmailsFromString = (string = '') => {
    return string
        .replaceAll('；', ';')
        .split(';')
        .map(item => item.trim())
        .filter(item => !!item);
};
export const polyfitDataByContact = (list) => {
    let traceMap = new Map();
    if (Array.isArray(list)) {
        list.forEach(item => {
            if (traceMap.has(item.contactEmail)) {
                let emailMap = traceMap.get(item.contactEmail);
                if (emailMap.has(item.traceUrl)) {
                    let urlArr = emailMap.get(item.traceUrl);
                    console.log('urlArr', urlArr);
                    emailMap.set(item.traceUrl, [...urlArr, item]);
                }
                else {
                    emailMap.set(item.traceUrl, [item]);
                }
            }
            else {
                let urlMap = new Map();
                urlMap.set(item.traceUrl, [item]);
                traceMap.set(item.contactEmail, urlMap);
            }
        });
    }
    let table = [];
    traceMap.forEach((innerMap, key1) => {
        innerMap.forEach((itemArr, key2) => {
            let item = Object.assign({ emialKey: key1, urlKey: key2, clickNums: itemArr === null || itemArr === void 0 ? void 0 : itemArr.length, combineTableData: itemArr }, itemArr[0]);
            table.push(item);
        });
    });
    return table;
};
export const polyfitDataByUrl = (list) => {
    let traceMap = new Map();
    if (Array.isArray(list)) {
        list.forEach(item => {
            if (traceMap.has(item.traceUrl)) {
                let urlArr = traceMap.get(item.traceUrl);
                traceMap.set(item.traceUrl, [...urlArr, item]);
            }
            else {
                traceMap.set(item.traceUrl, [item]);
            }
        });
    }
    let table = [];
    traceMap.forEach(innerArr => {
        let clickCount = 0;
        const clickCountMap = new Map();
        innerArr.forEach(itm => {
            if (!clickCountMap.has(itm.contactEmail)) {
                clickCount += 1;
                clickCountMap.set(itm.contactEmail, true);
            }
        });
        clickCountMap.clear();
        let item = Object.assign(Object.assign({ clickNums: innerArr === null || innerArr === void 0 ? void 0 : innerArr.length, combineTableData: innerArr }, innerArr[0]), { clickCount });
        table.push(item);
    });
    return table;
};
export const getPlainTextFromHtml = (html) => {
    if (!html)
        return '';
    return html
        .replace(/<[^>]+>/g, '')
        .replace(/\n/g, '')
        .replace(/\s/g, '')
        .replace(/&nbsp;/g, '');
};
export const createBeforeReadyListener = () => {
    const promises = [];
    return {
        add(promise) {
            promises.push(promise);
        },
        start() {
            return Promise.all(promises);
        },
    };
};
export const STORE_KEY = 'edmDirRemind';
export var UnsubscribeTextLan;
(function (UnsubscribeTextLan) {
    UnsubscribeTextLan["zh"] = "zh";
    UnsubscribeTextLan["en"] = "en";
    UnsubscribeTextLan["esp"] = "esp";
    UnsubscribeTextLan["ru"] = "ru";
    UnsubscribeTextLan["fr"] = "fr";
    UnsubscribeTextLan["pt"] = "pt";
    UnsubscribeTextLan["de"] = "de";
    UnsubscribeTextLan["vn"] = "vn";
    UnsubscribeTextLan["sa"] = "sa";
    UnsubscribeTextLan["korea"] = "korea";
    UnsubscribeTextLan["japan"] = "japan";
})(UnsubscribeTextLan || (UnsubscribeTextLan = {}));
const SendSettingCof = {
    value: 'SendSetting',
    id: 0,
    checked: false,
};
const ContentEditorCof = {
    value: 'ContentEditor',
    id: 1,
    checked: false,
};
const BatchSettingCof = {
    value: 'BatchSetting',
    id: 2,
    checked: false,
};
export const StepsMap = {
    SendSetting: Object.assign(Object.assign({}, SendSettingCof), { label: getIn18Text('RENWUSHEZHI') }),
    ContentEditor: Object.assign(Object.assign({}, ContentEditorCof), { label: getIn18Text('youjianneirong3') }),
    BatchSetting: Object.assign(Object.assign({}, BatchSettingCof), { label: getIn18Text('FASONGSHEZHI') }),
};
export const VersionSceneList = ['newCreate', 'marketingModal', 'innerContent'];
export const CreatePrevSceneList = ['copyTask', 'newCreate', 'draft'];
export const TemplatePrevSceneList = ['template', 'uniTemplate'];
export const MarketingPrevSceneList = ['customer', 'globalSearch', 'addressBook', 'customs', 'aisearch', 'linkedin', 'cantonfair', 'facebook', 'lbs', 'extension'];
export const ReceiversToContacts = (receivers) => {
    const contacts = receivers.map(i => ({
        email: i.contactEmail,
        name: i.contactName || '',
        companyName: i.companyName || '',
        continent: i.continent || '',
        country: i.country || '',
        province: i.province || '',
        city: i.city || '',
        variableMap: i.variableMap,
        sourceName: i.sourceName || '',
        recProduct: i.recProduct || '',
        increaseSourceName: i.increaseSourceName || '',
        cascadeId: i.cascadeId || '',
        position: i.position || '',
        remarks: i.remarks || '',
        verifyStatus: i.verifyStatus,
        verifyStatusList: i.verifyStatusList,
        contactStatus: i.contactStatus,
        contactStatusList: i.contactStatusList,
    }));
    return contacts;
};
export const MarketingVideo = {
    marketing: {
        downloadUrl: 'https://cowork-storage-public-cdn.lx.netease.com/lxbg/2023/03/25/eb737574d643496f8265dac30f012b54.mp4',
        previewUrl: 'https://cowork-storage-public-cdn.lx.netease.com/lxbg/2023/03/25/eb737574d643496f8265dac30f012b54.mp4',
        name: getIn18Text('YOUJIANYINGXIAO'),
        type: 'video',
        ext: 'mp4',
    },
    ai: {
        downloadUrl: 'https://cowork-storage-public-cdn.lx.netease.com/lxbg/2023/03/25/6d7fb61f89a04ed8acc7c232bc4e3782.mp4',
        previewUrl: 'https://cowork-storage-public-cdn.lx.netease.com/lxbg/2023/03/25/6d7fb61f89a04ed8acc7c232bc4e3782.mp4',
        name: getIn18Text('AIXIEXINYINGXIAO'),
        type: 'video',
        ext: 'mp4',
    },
    twice: {
        downloadUrl: 'https://cowork-storage-public-cdn.lx.netease.com/lxbg/2023/03/25/e66135d76c5c40e8a894bdfe4bbd566b.mp4',
        previewUrl: 'https://cowork-storage-public-cdn.lx.netease.com/lxbg/2023/03/25/e66135d76c5c40e8a894bdfe4bbd566b.mp4',
        name: getIn18Text('ZHINENGYINGXIAO'),
        type: 'video',
        ext: 'mp4',
    },
};
export const timeFormat = (time) => {
    const currentYear = moment(time).get('year');
    const targetYear = moment().get('year');
    if (currentYear === targetYear) {
        return moment(time).format('MM-DD HH:mm:ss');
    }
    return time !== null && time !== void 0 ? time : '';
};
export const getPercent = (item) => {
    let percentNumber = 0;
    let totalContactsCount = item.receiverCount || 0;
    let totalSendCount = item.sendCount;
    let emptySub = false;
    if (item.subList && item.subList.length > 0) {
        totalContactsCount = 0;
        totalSendCount = 0;
        item.subList.forEach(itm => {
            if (item.emailStatus !== 4) {
                totalContactsCount += itm.receiverCount || 0;
                totalSendCount += itm.sendCount || 0;
            }
            if (itm.receiverCount === 0) {
                emptySub = true;
            }
        });
    }
    percentNumber = (totalSendCount * 100) / totalContactsCount;
    percentNumber = percentNumber >= 100 ? 100 : percentNumber;
    if ((percentNumber >= 100 && emptySub) || !totalContactsCount) {
        return '';
    }
    const ceilNumber = Math.ceil(percentNumber);
    const floorNumber = Math.floor(percentNumber);
    percentNumber = percentNumber <= 99 ? ceilNumber : floorNumber;
    return percentNumber + '';
};
export const OneClickMarketingPrevSceneList = [
    'customer',
    'globalSearch',
    'smartrcmd',
    'addressBook',
    'customs',
    'aisearch',
    'linkedin',
    'cantonfair',
    'facebook',
    'lbs',
    'extension',
    'ffms',
    'templateV2',
];
export const ShowWeeklyTaskPages = ['mailTemplate', 'senderRotateList', 'warmup', 'drafts', 'autoMarketTask', 'aiHosting'];
export const getCurTimeStamp = () => {
    return new Date().valueOf();
};
export const judgeCustomer = (id) => {
    return [4, 7, 8, 9].includes(id);
};
export const judgeClue = (id) => {
    return [1, 3, 10, 11].includes(id);
};
export const localStorageRemove = (key) => {
    try {
        if (!localStorage) {
            return;
        }
        let keys = [];
        for (let i = 0; i < localStorage.length; i++) {
            const onKey = localStorage.key(i);
            if (onKey && onKey.indexOf(key) !== -1) {
                keys.push(onKey);
            }
        }
        keys.forEach(_ => localStorage.removeItem(_));
    }
    catch (err) { }
};
